/* eslint-disable */
(function () {
    "use strict";
    $(document).ready(function () {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");

        if (msie > 0) {     // If Internet Explorer, 
            
            $("#loginEIDHTML5Button").hide();
            $("#loginNoHTML5Button").show();
        } else {
            $("#loginEIDHTML5Button").show();
            $("#loginNoHTML5Button").hide();
        }
    });
}());